import BillingInvoicing from './Features/BillingInvoicing';
import GoogleOutlookCalendar from './Integrations/GoogleOutlookCalendar';

export default {
  BillingInvoicing,
  GoogleOutlookCalendar,
};
